import apiClient from "../client";

export interface AddParticipantsRequest {
  user_ids: string[];
}

export interface AddParticipantsResponse {
  success: boolean;
  message: string;
  data: null;
}

export const addParticipants = async (
  examAssignmentId: string,
  request: AddParticipantsRequest
): Promise<AddParticipantsResponse> => {
  const response = await apiClient.post(
    `/exam_assignments/${examAssignmentId}/participants`,
    request
  );
  return response.data;
}; 